import React, { useEffect, useState } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import utils from '../utils/utils'

function PurchaseItemRow({ session, setKey, ...props }) {

	const k = props.data;
	const quantity = parseInt(k.quantity);
	const price = parseFloat(k.selectedVariant.price);
	const total = quantity * parseFloat(k.selectedVariant.price);

	return (
		<>
			<tr key={k.id}>
				<td colSpan={2} className="text-start">	
					<input type="hidden" id="txt-productId" value={k.product._id} />
					<input type="hidden" id="txt-variantId" value={k.selectedVariant._id} />
					<div className="row text-start">
						<div className="col-5">
							<img
								className="cart-img"
								src={k.product.images[0].fileUrl}
							/>
						</div>
						<div className="col-7">
							<span className="truncate-2 td-strong">{k.product.title}</span>
							<span className="truncate-1">Size: {k.selectedVariant.size}</span>
						</div>
					</div>
				</td>
				<td>
					{utils.formatToCurrency(price, session.selectedRegion ? session.selectedRegion.currency : "EUR")}
				</td>
				<td className="">
					<span>{utils.formatToNumber(quantity)}</span>
				</td>
				<td className="text-end">
					<span>{utils.formatToCurrency(total, session.selectedRegion ? session.selectedRegion.currency : "EUR")}</span>
				</td>
			</tr>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseItemRow);
